import { useEffect } from "react";
import { useHistory, useLocation } from "react-router";
import Layout from "../../components/Layout";
import { Content, ReportTable } from "./styles";

interface IApiResponse{
    day: string;
    total: number;
}

interface IState{
    data: IApiResponse[];
    local: string;
}

export default function ShowActivesPropertiesPerPeriod(){
    const history = useHistory();

    const { state } = useLocation<IState>();

    useEffect(() => {
        if(!state){
            history.goBack();
        }
    }, [state, history]);

    return(
        <Layout>
            <Content>
                <h2>Imóveis Ativos por Período</h2>

                <div>{state.local[0].toLocaleUpperCase() + state.local.substring(1, state.local.length)}</div>

                <ReportTable>
                    <thead>
                        <tr>
                            <th>Dia</th>
                            <th>Total de imóveis</th>
                        </tr>
                    </thead>

                    <tbody>
                        {state.data.map((data, index) => (
                            <tr key={index}>
                                <td>{`${data.day.substring(8, 10)}/${data.day.substring(5, 7)}/${data.day.substring(0, 4)}`}</td>
                                <td id="td-total">{data.total}</td>
                            </tr>
                        ))}
                    </tbody>
                </ReportTable>
            </Content>
        </Layout>
    );
}